import React from "react";
import { Button, Container, Box } from "@mui/material";
import styles from "./style.module.scss";
import { useLocation, useHistory } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";

const NavigationButtons = () => {
  const history = useHistory();
  const location = useLocation();

  const buttons = [
    {
      path: "/studenttraining",
      label: "Training Modules",
      hideOn: "/studenttraining",
    },
    {
      path: "/assessments",
      label: "Assessments",
      hideOn: "/assessments",
    },
    // {
    //   path: "",
    //   label: "Progress",
    //   hideOn: "",
    // },
  ];

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mt: 4,
        px: 4,
      }}
    >
      {/* Back Button - Left Side */}
      <Button
        variant="contained"
        className={styles.button}
        onClick={() => history.push("/dashboard")} // Or specific path: history.push("/your-path")
        startIcon={<HomeIcon className={styles.icon} />} // Optional icon
        sx={{
          textTransform: "none",
          mr: "auto", // Pushes everything else to the right
        }}
      >
        Home
      </Button>
      <Box
        sx={{
          display: "flex",
          // justifyContent: "space-between",
          gap: 2,
        }}
      >
        {buttons.map(
          (button) =>
            location.pathname !== button.hideOn && (
              <Button
                key={button.path}
                variant="contained"
                className={styles.button}
                onClick={() => history.push(button.path)}
                sx={{
                  textTransform: "none",
                }}
              >
                {button.label}
              </Button>
            )
        )}
      </Box>
    </Container>
  );
};

export default NavigationButtons;
